/* @generated */

// src/assets/ui-icon/fill/globe.tsx
import * as React from "react";
var GlobeFill = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M10.024 10a61.559 61.559 0 0 0 0 3.5h3.45a61.56 61.56 0 0 0 0-3.5h-3.45Zm3.382 5h-3.312c.203 3.05.742 4.5 1.656 4.5.914 0 1.453-1.45 1.656-4.5ZM15 11.75c0 .61-.008 1.19-.023 1.75h4.412a13.85 13.85 0 0 0 0-3.5h-4.412c.015.56.023 1.14.023 1.75Zm-.086-3.25h4.153c-.723-2.366-2.369-3.783-4.963-4.286.51 1.373.783 2.822.81 4.286Zm-6.328 0c.027-1.464.301-2.913.811-4.286-2.595.5-4.24 1.92-4.964 4.286h4.153Zm0 6.5H4.433c.723 2.366 2.369 3.784 4.963 4.286A12.994 12.994 0 0 1 8.586 15Zm6.328 0a12.997 12.997 0 0 1-.811 4.286c2.595-.5 4.24-1.92 4.964-4.286h-4.153Zm-4.82-6.5h3.312C13.203 5.45 12.664 4 11.75 4c-.914 0-1.453 1.45-1.656 4.5ZM4.111 10a13.85 13.85 0 0 0 0 3.5h4.411a67.344 67.344 0 0 1 0-3.5H4.111Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  GlobeFill
};
